var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isModalVisible)?_c('v-dialog',{attrs:{"value":_vm.isShown,"max-width":"900","scrollable":""},on:{"input":_vm.onClose}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }